import { render } from "./AddCategory.vue?vue&type=template&id=62b2300a&scoped=true"
import script from "./AddCategory.vue?vue&type=script&lang=js"
export * from "./AddCategory.vue?vue&type=script&lang=js"

import "./AddCategory.vue?vue&type=style&index=0&id=62b2300a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b2300a"]])

export default __exports__